import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { 
  Building2,
  Package,
  DollarSign
} from 'lucide-react';
import ResponsiveNavigation from '@/components/ResponsiveNavigation';
import FormularyManager from '@/components/admin/FormularyManager';
import PharmacyManager from '@/components/admin/PharmacyManager';
import PricingMatrix from '@/components/admin/PricingMatrix';

const Admin = () => {
  return (
    <div className="min-h-screen bg-gray-50 font-lato">
      <ResponsiveNavigation />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-syne font-medium text-vitl-navy mb-2">Administration</h1>
          <p className="text-vitl-dark/70 font-lato">Manage formularies, pharmacies, and pricing across the platform</p>
        </div>

        {/* Admin Tabs */}
        <Tabs defaultValue="formularies" className="space-y-6">
          <TabsList className="grid w-full grid-cols-3 lg:w-[400px]">
            <TabsTrigger value="formularies" className="flex items-center space-x-2 font-lato">
              <Package className="w-4 h-4" />
              <span>Formularies</span>
            </TabsTrigger>
            <TabsTrigger value="pharmacies" className="flex items-center space-x-2 font-lato">
              <Building2 className="w-4 h-4" />
              <span>Pharmacies</span>
            </TabsTrigger>
            <TabsTrigger value="pricing" className="flex items-center space-x-2 font-lato">
              <DollarSign className="w-4 h-4" />
              <span>Pricing</span>
            </TabsTrigger>
          </TabsList>

          <TabsContent value="formularies" className="space-y-6">
            <FormularyManager />
          </TabsContent>

          <TabsContent value="pharmacies" className="space-y-6">
            <PharmacyManager />
          </TabsContent>

          <TabsContent value="pricing" className="space-y-6">
            <PricingMatrix />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
};

export default Admin;